@if (formFieldSignal(); as formField) {
    <div class="flex flex-col gap-2" 
    [ngClass]="{ 'hidden': formField.IsHidden }">
        @for (value of data; track $index) {
            @if(displayValues[$index] && formControl.value == value.CollectionFieldValuesID) {
                <div class="display-style flex items-center rounded-full px-1.5 py-0.5"
                [ngStyle]="{ 'background-color': displayValues[$index].BackgroundColor, 'color': displayValues[$index].ForegroundColor }">
                    <input [value]="value.CollectionFieldValuesID"  [formControl]="formControl"
                            id="{{formField.Id + '_' + value.CollectionFieldValuesID}}" [name]="'field_'+formField.Id"  type="radio" kendoRadioButton>
                    <label [for]="formField.Id + '_' + value.CollectionFieldValuesID"
                            class="ml-2 flex-1 cursor-pointer"
                           [class.text-danger]="!formField.aiGeneration && errorState != undefined"
                           [class.text-yellow-400]="!formField.aiGeneration?.confirmed && formField.aiGeneration?.generated && errorState != undefined && errorState.AiValidationError"
                    >{{ value.Caption }}</label>
                </div>
            }
            @else {
            <div class="flex items-start px-1.5 py-0.5">
                <div class="flex h-5 items-center">
                    <input [value]="value.CollectionFieldValuesID" [formControl]="formControl"
                           id="{{formField.Id + '_' + value.CollectionFieldValuesID}}" [name]="'field_'+formField.Id" type="radio" kendoRadioButton>
                </div>
                    <label [for]="formField.Id + '_' + value.CollectionFieldValuesID"
                        class="ml-2 flex-1 cursor-pointer"
                       [class.text-danger]="!formField.aiGeneration && errorState != undefined"
                       [class.text-yellow-400]="!formField.aiGeneration?.confirmed && formField.aiGeneration?.generated && errorState != undefined && errorState.AiValidationError"
                >{{ value.Caption }}</label>
            </div>
        }
    }
    </div>
}